<router-outlet></router-outlet>
<loader></loader>
